import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div>
       <footer className="footer">
      <div className="footer-container">
        {/* About Us Section */}
        {/* <div className="footer-section">
          <h3>About Us</h3>
          <ul>
            <li><a href="/about">About</a></li>
            <li><a href="/students">Students</a></li>
            <li><a href="/mission">Our Mission</a></li>
          </ul>
        </div> */}

        {/* Next Steps Section */}
        {/* <div className="footer-section">
          <h3>Next Steps</h3>
          <ul>
            <li><a href="/serving">Serving</a></li>
            <li><a href="/baptism">Baptism</a></li>
            <li><a href="/pray">Pray</a></li>
            <li><a href="/missions">Missions</a></li>
          </ul>
        </div> */}

        {/* Resources Section */}
        {/* <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><a href="/watch">Watch</a></li>
            <li><a href="/sermons">Sermons</a></li>
            <li><a href="/music">Music</a></li>
          </ul>
        </div> */}

        {/* Get Involved Section */}
        {/* <div className="footer-section">
          <h3>Get Involved</h3>
          <ul>
            <li><a href="/give">Give</a></li>
            <li><a href="/volunteer">Volunteer</a></li>
            <li><a href="/visit">Visit</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div> */}
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} M2C. All rights reserved.</p>
      </div>
    </footer>
    </div>
  )
}

export default Footer
